import React, { FC } from 'react';
import { useBackgroundContext } from '../BackgroundProvider';
import styles from './Header.css';
import { useSelector } from 'react-redux';
import { selectSuburbanRkTitle } from '../../../selectors/countryside';

export const CountrysideHeader: FC<React.PropsWithChildren> = ({ children }) => {
  const [backgroundImg] = useBackgroundContext();
  const suburbanRkTitle = useSelector(selectSuburbanRkTitle);

  return (
    <div className={styles['header']} style={{ backgroundImage: `url(${backgroundImg})` }} data-name="HeaderBlock">
      <div className={styles['content']}>
        <div className={styles['inner']}>
          <div className={styles['title']}>{suburbanRkTitle || 'Дома, дачи и участки'}</div>
          {children}
        </div>
        {!suburbanRkTitle && <div className={styles['overlay']} />}
      </div>
    </div>
  );
};
